import { mockNavigationLink } from '@domgen/dgx-fe-common';
import { AccordionArticleFilterItem } from '@domgen/dgx-fe-components/accordion';

export const mockAccordionArticleFilterItem: AccordionArticleFilterItem = {
  title: 'articles',
  accordionArticles: [
    {
      id: 'id',
      navigationLink: mockNavigationLink,
      snippet: 'snippet',
      title: 'Boiler',
    },
  ],
};
